"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = void 0;
const react_1 = __importStar(require("react"));
const popovers_1 = require("../../modals/popovers");
const EditableTitle_1 = require("../EditableTitle");
const TextArea_styles_1 = require("./TextArea.styles");
const TextArea = ({ value, onChange, id, disabled, label, placeholder, tooltip, subtitleText, warningText, errorText, translationKey, translationEditHandler, }) => {
    const [valueState, setValueState] = (0, react_1.useState)(value);
    (0, react_1.useEffect)(() => {
        if (valueState !== value) {
            onChange(valueState);
        }
    }, [onChange, value, valueState]);
    const getTooltipType = (warningText, tooltip) => {
        if (errorText) {
            return "error";
        }
        else if (warningText) {
            return "conflict";
        }
        else if (tooltip) {
            return "info";
        }
        return "empty";
    };
    return (react_1.default.createElement(TextArea_styles_1.TextAreaWrapper, null,
        label && (react_1.default.createElement(TextArea_styles_1.LabelWrapper, { "$hasError": !!errorText, "$hasWarning": !!warningText, "$isDisabled": disabled },
            react_1.default.createElement(EditableTitle_1.EditableTitle, { name: label, controlElemId: id, editHandler: (isCancelled, value) => translationEditHandler && value && translationEditHandler(isCancelled, value, translationKey), isEditable: !!translationKey }))),
        (warningText || tooltip) && (react_1.default.createElement(popovers_1.Tooltip, { message: errorText || warningText || tooltip || "", type: getTooltipType(errorText || warningText, tooltip), translationKey: translationKey, translationEditHandler: (isCancelled, value) => translationEditHandler && translationEditHandler(isCancelled, value) })),
        react_1.default.createElement(TextArea_styles_1.TextAreaContainer, { "$value": valueState, onChange: (e) => setValueState(e.target.value), id: id, disabled: disabled, placeholder: placeholder, "$hasWarning": !!warningText, "$hasError": !!errorText }),
        react_1.default.createElement(TextArea_styles_1.HelperTextWrapper, { "$hasError": !!errorText, "$hasWarning": !!warningText }, errorText || warningText || subtitleText || "")));
};
exports.TextArea = TextArea;
//# sourceMappingURL=TextArea.js.map